dom.hasClass = (target, className) => {
	return target.className.indexOf(className) !== -1;
};
